import React, { useState } from 'react';
import { Menu, MenuItem, IconButton } from '@mui/material';
import SortIcon from '@mui/icons-material/Sort';

const SeekerOffersFilter = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      {/* Sort Icon Button */}
      <IconButton
        onClick={handleClick}
        sx={{
          backgroundColor: 'transparent !important', // Force remove background
          '&:hover': { backgroundColor: 'transparent !important' },
          '& span': { backgroundColor: 'transparent !important' }, // Remove background from span elements inside
          padding: 0,
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <SortIcon />
      </IconButton>
      {/* Menu with minWidth 200px */}
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        sx={{ '& .MuiPaper-root': { minWidth: 200 } }}
      >
        <MenuItem onClick={handleClose} disableRipple>Newest First</MenuItem>
        <MenuItem onClick={handleClose} disableRipple>Expires Soon</MenuItem>
      </Menu>
    </>
  );
};

export default SeekerOffersFilter;
